var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { getCssThemeColorVariable } from '@theme';
import { Heading } from '@chakra-ui/react';
const getHeadingSize = (type) => {
    switch (type) {
        case 'h1':
            return '4xl';
        case 'h2':
            return { base: 'xl', sm: '3xl' };
        case 'h3':
            return { base: 'lg', sm: 'xl' };
        case 'h4':
            return { base: 'lg', sm: 'lg' };
        default:
            return { base: 'md', sm: 'md' };
    }
};
export const Title = (_a) => {
    var { className, color = 'neutral.900', size, testid, type } = _a, props = __rest(_a, ["className", "color", "size", "testid", "type"]);
    return (_jsx(Heading, Object.assign({ as: type }, props, { className: ['cb-title-text', className].filter(Boolean).join(' '), color: color, "data-testid": testid, size: size !== null && size !== void 0 ? size : getHeadingSize(type), sx: Object.assign({ '--cb-title-text--color': `var(${getCssThemeColorVariable(color)})` }, props.sx) })));
};
